<template>
  <div class="checkIn_business">
    <div class="inner_header">
      <img src="../assets/images/arrow-b.svg" @click="$router.go(-1)" />
    </div>

    <div class="checkIn_mid_container">
      <div class="title_block">
        <h2>{{$t('CheckInAtAdda')}}</h2>
        <p>{{$t('ShareExperience')}}</p>
      </div>
      <div class="business_form_block">
        <div class="business_block">
          <label for="Category">{{$t('AddaName')}}</label>
          <input
            type="text"
            :placeholder="$t('AddAdda')"
            v-if="!selectCheckInShop"
            v-model="checkInToShop"
            @input="check($event.target.value)"
            @click="isShow = !isShow"
          />
          <p v-if="selectCheckInShop" :class="{'addselectCheckIn' : selectCheckInShop}">
            <span>{{selectedShopDetail.shopName}}, {{selectedShopDetail.shopAddress}}</span>
            <!-- <i
              v-if="!Object.keys(this.$route.params).length"
              class="material-icons"
              @click.prevent="selectCheckIn()"
            >clear</i>-->
          </p>
          <div class="AllBusinessList checkin_location" v-if="isShow">
            <div class="addnewbusiness">
              <div class="add-category">
                <span class="addcategory_btn" @click="redirectToAddAdda">+ {{$t('AddAddanotfound')}}</span>
              </div>
            </div>
            <ul class="business-listing-checkin">
              <li v-for="(item, index) in filteredList" :key="index" @click="addShopPlace(item)">
                <span class="place-pic">
                  <img :src="item.images[0]" v-if="item.images[0]" />
                  <img src="../assets/images/placeholderImg.png" v-else />
                </span>
                <div class="bunsiness-details">
                  <p>
                    <span>{{item.business_name}}</span>
                    <span>
                      <img src="../assets/images/ic-walk.svg" />
                      {{item.distance}}
                    </span>
                  </p>
                  <span class="business-listing-location">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                    >
                      <g class="b" transform="translate(-343 -175)">
                        <path
                          class="c"
                          d="M5.4-5.28a.752.752,0,0,0,1.237,0c4.553-6.6,5.4-7.278,5.4-9.7A6.016,6.016,0,0,0,6.016-21,6.016,6.016,0,0,0,0-14.984C0-12.558.845-11.881,5.4-5.28Zm.618-7.2A2.507,2.507,0,0,1,3.51-14.984,2.507,2.507,0,0,1,6.016-17.49a2.507,2.507,0,0,1,2.507,2.507A2.507,2.507,0,0,1,6.016-12.477Z"
                          transform="translate(346 197)"
                        />
                      </g>
                    </svg>
                    <span>{{item.address.street}}</span>
                  </span>
                  <span class="review-part">
                    <star-rating :read-only="true" :rating="item.rating"></star-rating>
                  </span>
                </div>
              </li>
            </ul>
          </div>

          <!-- 
          <div class="add-category">
            <span class="addcategory_btn">+ अड्डा नहीं मिला जोड़े </span>
          </div>-->
        </div>
        <div class="business_block">
          <label for="business_name">{{$t('Iamhere')}}</label>

          <div class="add_location">
            <img src="../assets/images/ic_map_location.svg" />
            <p v-if="selectCheckInShop">
              <span>{{selectedShopDetail.shopName}}, {{selectedShopDetail.shopAddress}}</span>
            </p>
          </div>
          <div class="map_location">
            <!-- <google-map /> -->
          </div>

          <!-- <div class="map-img">
            <img src="../assets/images/map.jpeg" />
          </div>-->
        </div>
        <div class="checkIn_comment">
          <textarea v-model="whatsInMind" :placeholder="$t('Writesomethinghere')"></textarea>
        </div>
        <div class="photo_upload_block">
          <span :class="uploadCheckInPhoto=='' ?  'add_photo':'add_photo disable' ">
            <label class="file">
              <span class="file-custom">
                <input
                  type="file"
                  id="file"
                  ref="myFiles"
                  accept="image/*"
                  @change="uploadPhoto"
                  multiple="multiple"
                  :disabled="uploadCheckInPhoto!=''"
                />
                <img src="../assets/images/camera.svg" class="camera_icon" />
                <span class="addphoto_text">फ़ोटो जोड़ें</span>
              </span>
            </label>
          </span>
        </div>
        <div class="img_upload_block">
          <ul>
            <li>
              <img :src="uploadCheckInPhoto" v-if="uploadCheckInPhoto" :alt="uploadCheckInPhoto" />
              <img v-else src="../assets/images/placeholder.jpg" />

              <span class="cross_icon" @click="changePhoto()">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                  <g transform="translate(-8 -2)">
                    <path
                      class="a"
                      d="M9,2a7,7,0,1,0,7,7A6.994,6.994,0,0,0,9,2Zm3.5,9.513-.987.987L9,9.987,6.487,12.5,5.5,11.513,8.013,9,5.5,6.487,6.487,5.5,9,8.013,11.513,5.5l.987.987L9.987,9Z"
                      transform="translate(6)"
                    />
                  </g>
                </svg>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>
    <div class="ckeckIn_button">
      <Button
        :btn_txt="$t('plzCheckin')"
        btn_cls="checkIntBtn"
        @checkInBusiness="checkInToBusiness()"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import types from "../store/types";
import Vue from "vue";
import VueCookie from "vue-cookie";
import InfiniteLoading from "vue-infinite-loading";
import ApiCaller from "../utils/apicaller";
import { toaster } from "../utils/helper";
import { FILE_UPLOAD_URL } from "../utils/constant";
import axios from "axios";
import Button from "../components/common/Button";
import GoogleMap from "../components/GoogleMap";
import { getBase64Url } from "../utils/helper";
Vue.use(InfiniteLoading);
Vue.use(VueCookie);
export default {
  name: "CheckInBusiness",
  components: {
    Button,
    GoogleMap
  },
  data() {
    return {
      isShow: false,
      checkinBusinessList: [],
      checkInToShop: "",
      whatsInMind: "",
      longitude: "",
      latitude: "",
      uploadCheckInPhoto: "",
      selectCheckInShop: false,
      checkInToShopId: "",
      isDisable: false,
      selectedShopDetail: {
        shopName: "",
        shopImage: "",
        shopAddress: ""
      },
      loading: false
    };
  },
  computed: {
    ...mapState(["business"]),
    filteredList: function() {
      let businessList = [];
      if (Object.keys(this.$route.params).length) {
        businessList.push(this.$route.params);
      } else {
        businessList = this.$store.state.business;
      }
      return businessList.filter(item =>
        item.business_name
          .toLowerCase()
          .includes(this.checkInToShop.toLowerCase())
      );
    }
  },
  methods: {
    changePhoto() {
      document.getElementById("file").value = null;
      this.uploadCheckInPhoto = "";
    },
    uploadPhoto(file) {
      if (this.uploadCheckInPhoto == "") {
        let image = file.target.files[0];
        if (!image.type.includes("image/")) {
          alert("Please select an image file");
          return;
        }
        getBase64Url(image).then(data => {
          this.uploadCheckInPhoto = data;
        });
      }
    },
    check(e) {
      this.checkInToShop = e;
    },
    selectCheckIn() {
      (this.checkInToShop = ""),
        (this.selectCheckInShop = !this.selectCheckInShop);
    },
    redirectToAddAdda() {
      this.$router.push("/add-new-business");
    },
    addShopPlace(item) {
      this.isShow = !this.isShow;
      this.selectCheckInShop = !this.selectCheckInShop;
      this.checkInToShop = item.business_name;
      this.checkInToShopId = item.id;
      this.selectedShopDetail.shopName = item.business_name;
      this.selectedShopDetail.shopImage = item.images;
      this.selectedShopDetail.shopAddress = item.address.street;
    },
    async checkInToBusiness() {
      if (
        !this.checkInToShop == "" &&
        !this.whatsInMind == "" &&
        !this.uploadCheckInPhoto == ""
      ) {
        this.loading = true;
        var checkInDoc = {
          checkInToShop: this.checkInToShopId || this.$route.params.id,
          whatsInMind: this.whatsInMind,
          uploadCheckInPhoto: this.uploadCheckInPhoto,
          longitude: VueCookie.get("longitude"),
          latitude: VueCookie.get("latitude")
        };
        if (!VueCookie.get("longitude") && !VueCookie.get("latitude")) {
          try {
            __native_money91.location = (res, locatnPermission) => {
              if (!res && locatnPermission === "LOCATION_PERMISSION_DENIED") {
                alert("Please Enable Your App Permission");
              } else if (!res && locatnPermission === "LOCATION_NOT_ENABLED") {
                alert("Please Enable your App Location.");
              }
            };
            JSBridgePlugin.getLocation(" __native_money91.location");
          } catch (err) {
            console.log(err);
          }
        }
        this.$store
          .dispatch({ type: "postCheckIn", payload: checkInDoc })
          .then(data => {
            if (data.status == "Success") {
              this.loading = false;
              this.$store.commit(types.LOADFEEDS, []);
              this.$router.push("/wall");
            }
          })
          .catch(err => {
            toaster(this, this.$t("wentWrong"), "top-center", 2000);
          });
      } else {
        toaster(this, this.$t("PleaseEnterdetails"), "top-center", 2000);
      }
    }
  },
  mounted() {
    let businessList = [];
    if (Object.keys(this.$route.params).length) {
      businessList.push(this.$route.params);
      this.checkInToShop = this.$route.params.id;
      this.selectCheckInShop = true;
      this.selectedShopDetail.shopName = this.$route.params.business_name;
      this.selectedShopDetail.shopAddress = this.$route.params.address.street;
    }
    this.$store.dispatch({ type: "getBusiness" });
  }
};
</script>
<style>
.map_location .gm-style-mtc {
  display: none;
}
</style>
